import React from "react";
import { View } from "react-native";
import commonStyles, { SCREEN_WIDTH } from "../styles/commonStyles";

/**
 * Implémentation Web spécifique pour la lecture YouTube.
 *
 * On évite d'utiliser `react-native-youtube-iframe` sur le web car
 * son intégration avec WebView s'attend à la présence de
 * `window.ReactNativeWebView`, ce qui provoque des erreurs
 * JavaScript dans la console (`postMessage` sur undefined).
 *
 * Ici on utilise simplement un `<iframe>` YouTube classique.
 */
const Youtube = ({ route }) => {
	const { videoId } = route.params;
	const { w100p, h100p, justifyContentCenter, bgColor1 } = commonStyles;

	const height = (SCREEN_WIDTH * 9) / 16;

	return (
		<View style={[w100p, h100p, justifyContentCenter, bgColor1]}>
			<iframe
				title="youtube-player"
				width={SCREEN_WIDTH}
				height={height}
				src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
				frameBorder="0"
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
				allowFullScreen
				style={{ border: 0, maxWidth: "100%" }}
			/>
		</View>
	);
};

export default Youtube;

